export enum IrbFooterDialogEvents {
    SHOW_FOOTER_DIALOG = "IRBFOOTERDIALOGEVENTS.SHOW_FOOTER_DIALOG",
    SHOW_MMC_FOOTER_DIALOG = "IRBFOOTERDIALOGEVENTS.SHOW_MMC_FOOTER_DIALOG"
}
